<template>
  <Modal
    :modal="modal"
    title="Informe a Parcela"
    @close="$emit('close')"
    @save="save"
    @refresh="getTiposDocumentoAPI"
    :loading="loading"
  >
    <v-row>
      <v-col cols="12" class="pt-0">
        <ModalEmissao
          :modal="modalEmissao"
          :editEmissao="editEmissao"
          @close="closeModalEmissao"
          @save="changeVencimento"
        />
        <v-form v-model="valid" ref="formParcela" lazy-validation>
          <v-autocomplete
            v-model="parcela.tipo_documento"
            :items="tiposDocumento"
            item-text="tipo_documento"
            return-object
            label="Tipo Documento"
            no-data-text="Nenhum registro encontrado"
            :loading="loading"
            @change="changeTipoDocumento"
            :rules="[rules.required]"
          ></v-autocomplete>
          <v-text-field
            type="number"
            v-model.number="parcela.valor_parcela"
            label="Valor"
            :rules="[rules.greaterThanZero]"
          ></v-text-field>
          <v-text-field
            :value="formattedVencimento"
            label="Vencimento"
            readonly
            hide-details
            @click="openModalEmissao"
          ></v-text-field>
        </v-form>
      </v-col>
    </v-row>
    <v-row v-if="editParcela">
      <v-col cols="12" class="text-center">
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          color="error"
          small
          @click="$emit('remove', parcela)"
        >Remover</v-btn>
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Modal from '@/components/shared/Modal';
import ModalEmissao from '@/components/shared/ModalEmissao';

export default {
  name: 'ModalParcela',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editParcela: {
      default: null
    },
    valorRestante: {
      default: 0
    }
  },
  components: {
    Modal,
    ModalEmissao,
  },
  data: () => ({
    loading: false,
    valid: true,
    modalEmissao: false,
    editEmissao: null,
    parcela: {
      id_tipo_documento: null,
      tipo_documento: '',
      data_vencimento: new Date().toISOString().substr(0, 10),
      valor_parcela: 0
    },
  }),
  computed: {
    ...mapGetters(['tiposDocumento', 'rules']),
    formattedVencimento() {
      if (typeof this.parcela.data_vencimento === 'object') {
        return this.parcela.data_vencimento.toISOString().substr(0, 10).split('-').reverse().join('/');
      } else {
        return this.parcela.data_vencimento.split('-').reverse().join('/');
      }
    }
  },
  methods: {
    ...mapActions(['fetchTiposDocumento', 'fetchTiposDocumentoAPI']),
    ...mapMutations(['SHOW_SNACKBAR']),
    openModalEmissao() {
      this.editEmissao = this.parcela.data_vencimento;
      this.modalEmissao = true;
    },
    closeModalEmissao() {
      this.editEmissao = null;
      this.modalEmissao = false;
    },
    changeVencimento(vencimento) {
      this.parcela.data_vencimento = vencimento;
      this.editEmissao = null;
      this.modalEmissao = false;
    },
    changeTipoDocumento(obj) {
      this.parcela.id_tipo_documento = obj.id_tipo_documento;
      this.parcela.tipo_documento = obj.tipo_documento;
    },
    getTiposDocumento() {
      this.loading = true;
        this.fetchTiposDocumento()
          .then(() => this.loading = false);
    },
    getTiposDocumentoAPI() {
      this.loading = true;
        this.fetchTiposDocumentoAPI()
          .then(() => this.loading = false);
    },
    validateParcela() {
      return this.$refs.formParcela.validate();
    },
    save() {
      if (!this.editParcela && this.validateParcela()) {
        const newParcela = { ...this.parcela };
        this.$emit('save', newParcela);
      } else if (this.editParcela && this.validateParcela()) {
        const editParcela = { ...this.parcela };
        this.$emit('update', editParcela);
      }
    }
  },
  watch: {
    modal(value) {
      if (value && !this.tiposDocumento.length && !this.loading) {
        this.parcela.valor_parcela = this.valorRestante.toFixed(2);
        this.getTiposDocumento();
      } else if (this.valorRestante > 0) {
        this.parcela.valor_parcela = this.valorRestante.toFixed(2);
      } else {
        this.parcela = {
          id_tipo_documento: null,
          tipo_documento: '',
          data_vencimento: new Date().toISOString().substr(0, 10),
          valor_parcela: 0
        };
      }
    },
    editParcela(value) {
      if (value) this.parcela = value;
    }
  }
}
</script>

<style>

</style>